module.exports = __webpack_public_path__ + "img/horizontal_4_1_9005.7e8169fd.png";